<template>
    <page title="confirmTitle">
        <template #pageContainer>
            <div v-if="isEmailConfirmed">
                {{ $t(`text.confirmation`) }}
                <nav-item :to="{name: 'login'}" title="login"></nav-item>
            </div>
        </template>
    </page>
</template>

<script>
import { mapActions } from 'vuex';

import authActions from '../store/actions/auth';
import namespace from '../store/namespace';

import Page from '../general/Page.vue';
import NavItem from '../navigation/Item.vue';

export default {
	name: 'Confirm',
	components: {
		Page,
		NavItem,
	},
	async mounted() {
		const confirmation = {
			userId: this.userId,
			code: this.code,
		};

		await this.CONFIRM(confirmation);
		this.confirmed = true;
	},
	data() {
		return {
			userId: this.$route.query.userId,
			code: this.$route.query.code,
			confirmed: false,
		};
	},
	computed: {
		isEmailConfirmed() {
			return this.confirmed === true;
		},
	},
	methods: {
		...mapActions(namespace.AUTH, [authActions.CONFIRM]),
	},
};
</script>
